import xs from "xstream";
import * as actions from "../actions";
import * as ActionTypes from "../actions/types";
import { NEW_BASE_URL } from "../config";
import { generalHeader } from "./headers";
import { createBackendRequest } from "../mappers/backendMappers";
import sampleCombine from "xstream/extra/sampleCombine";

const REQUEST_CHECK_IF_ANALYTICS_ENABLED = "requestCheckIfAnalyticsAreEnabled";
const REQUEST_AGGREGATE_PER_ENDPOINT_PER_DAY =
  "requestAggregatePerEndpointPerDayStatistics";
const REQUEST_AGGREGATE_STATISTICS = "requestAggregateStatistics";

export function requestCheckIfAnalyticsAreEnabled(sources) {
  const state$ = sources.STATE;
  const csrfToken$ = state$.map((state) => state.applicationUser?.token);
  const userId$ = state$.map((state) => state.applicationUser?.uuid);
  const request$ = sources.ACTION.filter(
    (action) => action.type === ActionTypes.CHECK_IF_ANALYTICS_ARE_ENABLED
  )
    .compose(sampleCombine(csrfToken$, userId$))
    .map(([action, csrfToken, userId]) => ({
      url: NEW_BASE_URL + "/Analytics/enabled",
      category: REQUEST_CHECK_IF_ANALYTICS_ENABLED,
      method: "POST",
      headers: generalHeader(csrfToken, true),
      send: createBackendRequest({}, userId),
      withCredentials: true,
    }));

  const httpResponse$ = sources.HTTP.select(REQUEST_CHECK_IF_ANALYTICS_ENABLED)
    .map((response) => response.replaceError((err) => xs.of(err)))
    .flatten()
    .map((response) =>
      response.status === 200
        ? actions.checkIfAnalyticsAreEnabledSuccess(response)
        : actions.checkIfAnalyticsAreEnabledFailed(response)
    );

  return {
    ACTION: httpResponse$,
    HTTP: request$,
  };
}

// Mirrors the old Drupal route mapping: this stream feeds the "per day" UI state
// but, like the old /phpsdk/app-analytics/sumAggregates route it calls, it resolves
// to NbgAnalyticsApi*SumAggregatesPerEndpointUrl (not the *PerDay* one) on the backend.
export function requestAggregatePerEndpointPerDayStatistics(sources) {
  const state$ = sources.STATE;
  const userId$ = state$.map((state) => state.applicationUser?.uuid);
  const csrfToken$ = state$.map((state) => state.applicationUser?.token);

  const request$ = sources.ACTION.filter(
    (action) =>
      action.type ===
      ActionTypes.FETCH_AGGREGATES_PER_ENDPOINT_PER_DAY_STATISTICS
  )
    .compose(sampleCombine(csrfToken$, userId$))
    .map(([action, csrfToken, userId]) => ({
      url: NEW_BASE_URL + "/Analytics/sumAggregates",
      category: REQUEST_AGGREGATE_PER_ENDPOINT_PER_DAY,
      method: "POST",
      headers: generalHeader(csrfToken, true),
      send: createBackendRequest(
        {
          ApplicationClientId: action.payload.queryConfig.application,
          FromDate: action.payload.queryConfig.fromDate,
          ToDate: action.payload.queryConfig.toDate,
        },
        userId
      ),
      withCredentials: true,
    }));

  const httpResponse$ = sources.HTTP.select(
    REQUEST_AGGREGATE_PER_ENDPOINT_PER_DAY
  )
    .map((response) => response.replaceError((err) => xs.of(err)))
    .flatten()
    .map((response) =>
      response.status === 200
        ? actions.fetchAggregatesPerEndpointPerDayStatisticsSuccess(response)
        : actions.fetchAggregatesPerEndpointPerDayStatisticsFailed(response)
    );

  return {
    ACTION: httpResponse$,
    HTTP: request$,
  };
}

// Mirrors the old Drupal route mapping: this stream feeds the plain per-endpoint UI
// state but, like the old /phpsdk/app-analytics/aggregates route it calls, it resolves
// to NbgAnalyticsApi*SumAggregatesPerEndpointPerDayUrl on the backend.
export function requestAggregateStatistics(sources) {
  const state$ = sources.STATE;
  const userId$ = state$.map((state) => state.applicationUser?.uuid);
  const csrfToken$ = state$.map((state) => state.applicationUser?.token);

  const request$ = sources.ACTION.filter(
    (action) =>
      action.type === ActionTypes.FETCH_AGGREGATES_PER_ENDPOINT_STATISTICS
  )
    .compose(sampleCombine(csrfToken$, userId$))
    .map(([action, csrfToken, userId]) => ({
      url: NEW_BASE_URL + "/Analytics/aggregates",
      category: REQUEST_AGGREGATE_STATISTICS,
      method: "POST",
      headers: generalHeader(csrfToken, true),
      send: createBackendRequest(
        {
          ApplicationClientId: action.payload.queryConfig.application,
          FromDate: action.payload.queryConfig.fromDate,
          ToDate: action.payload.queryConfig.toDate,
        },
        userId
      ),
      withCredentials: true,
    }));

  const httpResponse$ = sources.HTTP.select(REQUEST_AGGREGATE_STATISTICS)
    .map((response) => response.replaceError((err) => xs.of(err)))
    .flatten()
    .map((response) =>
      response.status === 200
        ? actions.fetchAggregatesPerEndpointStatisticsSuccess(response)
        : actions.fetchAggregatesPerEndpointStatisticsFailed(response)
    );

  return {
    ACTION: httpResponse$,
    HTTP: request$,
  };
}
